import React from 'react'
import { CellRenderer } from '../../legacy-design-system/grid'
import { Route, RouteStatus } from '../../graphql/schema/types/route'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'

const statusCellCss = css`
  padding: 8px;
  text-align: left;
`

export const routeStatusI18nConfig: Record<RouteStatus, string> = {
  DISCOVERED: 'title_route_discovered',
  EXERCISED: 'title_applicationRouteCoverage_exercised',
  EXCLUDED: 'title_applicationRouteCoverage_excluded'
}

export function getStatusCellRenderer(): CellRenderer<Route> {
  return function statusCellRenderer({
    rowData: { status },
    getCellContentProps
  }) {
    return (
      <div {...getCellContentProps({ className: statusCellCss })}>
        <FormattedMessage id={routeStatusI18nConfig[status]} />
      </div>
    )
  }
}
